const entsManager = {
  path: '/entsManager',
  component: resolve => require(['../../../../pages/modules/entsManager'], resolve),
  meta: {
    requireAuth: true
  }
}

export default entsManager